/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {JsonApiResource} from "@irian-ro/abstract-resource";
import {UserModel} from "@irian-ro/auth-web-client";
import { HttpClient, HttpParams } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

@Injectable({providedIn: 'root'})
export class UserCompanyTypeResourceService{

  url: string | undefined = undefined;

  constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    this.url = environmentService.getEnvironmentProperty('usersUrl');
  }

  findTemplateByCompanyType(companyType: CompanyType): Observable<JsonApiResource<UserModel, any>>{
    return this.httpClient.get<JsonApiResource<UserModel, any>>(`${this.url}/newUser/company-type`, {params: this.getCompanyTypeHttpParams(companyType)});
  }

  findOneByCompanyType(uuid: string, companyType: CompanyType): Observable<JsonApiResource<UserModel, any>>{
    return this.httpClient.get<JsonApiResource<UserModel, any>>(`${this.url}/details/${uuid}/company-type`, {params: this.getCompanyTypeHttpParams(companyType)});
  }

  private getCompanyTypeHttpParams(companyType: CompanyType){
    let params = new HttpParams();
    if(companyType != null){
      params = params.set('companyType', companyType);
    }

    return params;
  }

}
